// © 2015-2021 WDNA - All Rights Reserved

import * as React from 'react';

import { ConnectedRouter } from 'connected-react-router/immutable';
import { HashRouter } from 'react-router-dom';
import { History } from 'history';

import routes from './routes';

interface Props {
  history: History;
}

const App = ({ history }: Props): JSX.Element => {
  return (
    <ConnectedRouter history={history}>
      <HashRouter>{routes}</HashRouter>
    </ConnectedRouter>
  );
};

export default App;
